import { useEffect } from 'react';
import { RouterProvider } from 'react-router';
import { router } from './router';
import { useReaderStore } from './stores/reader';
import { ErrorBoundary } from './components/ErrorBoundary';
import { ConfirmDialog } from './components/ConfirmDialog';
import { OfflineBanner } from './lib/hooks/use-online-status'; // from .tsx file

export function App() {
  const theme = useReaderStore((s) => s.settings.theme);

  // 全局主题应用——在 App 层，对所有页面生效
  useEffect(() => {
    const root = document.documentElement;

    // 清除所有主题 class
    root.classList.remove('dark');

    if (theme === 'dark') {
      root.classList.add('dark');
      root.style.backgroundColor = '#1E1A16';
      root.style.colorScheme = 'dark';
    } else if (theme === 'sepia') {
      // 护眼：暖色背景，不用 dark class
      root.style.backgroundColor = '#F5E6D3';
      root.style.colorScheme = 'light';
      // 给 body 也加护眼背景（覆盖 Tailwind 默认）
      document.body.style.backgroundColor = '#F5E6D3';
    } else {
      // 日间
      root.style.backgroundColor = '';
      root.style.colorScheme = 'light';
      document.body.style.backgroundColor = '';
    }
  }, [theme]);

  return (
    <ErrorBoundary>
      <OfflineBanner />
      <RouterProvider router={router} />
      <ConfirmDialog />
    </ErrorBoundary>
  );
}
